import { JSX, useMemo } from "react";

import { Cached } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { invalidateCache } from "src/api/extendedAnalytics.api";
import { UserApiRole } from "src/constants/userRoles.enum";
import { getApiRolesFromUser } from "src/lib/user.helper";

const ALLOWED_INSIGHTS_REFRESH_ROLES = new Set([
  UserApiRole.Superadmin.toString(),
  UserApiRole.Admin.toString(),
  UserApiRole.Superuser.toString(),
]);

function RefreshButton(): JSX.Element | null {
  const { t } = useTranslation();
  const auth = useAuth();
  const userApiRoles = useMemo(() => getApiRolesFromUser(auth.user), [auth.user]);
  const hasAccess = useMemo(() => userApiRoles.some((role) => ALLOWED_INSIGHTS_REFRESH_ROLES.has(role)), [userApiRoles]);

  if (!hasAccess) {
    return null;
  }

  return (
    <Box ml={0.5}>
      <Tooltip title={t("Refresh dashboard list")}>
        <IconButton onClick={() => invalidateCache()}>
          <Cached />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default RefreshButton;
